import React from 'react';

interface DataQualityOverlayProps {
  hasZeroValues: boolean;
  hasIncorrectReferenceRange: boolean;
  referenceRangeError?: string;
  correctReferenceRange?: { min: number; max: number };
  onFixReferenceRange?: () => void;
}

export const DataQualityOverlay: React.FC<DataQualityOverlayProps> = ({
  hasZeroValues,
  hasIncorrectReferenceRange,
  referenceRangeError,
  correctReferenceRange,
  onFixReferenceRange
}) => {
  if (!hasZeroValues && !hasIncorrectReferenceRange) {
    return null;
  }

  const issueCount = (hasZeroValues ? 1 : 0) + (hasIncorrectReferenceRange ? 1 : 0);
  const primaryIssue = hasIncorrectReferenceRange ? 'reference' : 'zero';

  return (
    <div className="absolute top-2 left-2 right-2 z-10">
      <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <svg className="w-5 h-5 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div className="text-sm">
              <span className="text-red-800 font-medium">
                Data Quality Issue{issueCount > 1 ? 's' : ''} Detected
              </span>
              {hasIncorrectReferenceRange && correctReferenceRange && (
                <span className="text-red-600 ml-2">
                  • Reference range should be {correctReferenceRange.min}-{correctReferenceRange.max}
                </span>
              )}
              {hasZeroValues && (
                <span className="text-red-600 ml-2">
                  • Zero values found (X marks on chart)
                </span>
              )}
            </div>
          </div>
          {onFixReferenceRange && primaryIssue === 'reference' && (
            <button
              onClick={onFixReferenceRange}
              className="text-xs bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 flex-shrink-0"
            >
              Fix Range
            </button>
          )}
        </div>
      </div>
    </div>
  );
};